import api from '@/api/api';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getASINInfo: (context, asin) => {
    const regexp = /^[A-Z0-9]{10}$/;
    if (!regexp.test(asin)) return null;

    return api().get(`/analyzer/get_info/${asin}`)
      .then((resp) => resp.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
